module.exports = __webpack_public_path__ + "img/icons8-microsoft-word-2019.860c5668.svg";